export const PAGESIZE = 7;
export const DEFAULTPAGE = 0;
export const SELECTVALUE = 'Todos';
export const IDSELECTVALUE = -1;
export const DEFAULTVALUE = 'Desvincular Selección';
export const STATESELECTED = 'Todos';
export const UNDEFINEDSELECTED = 'undefined';

export const TABLE_ICON_STROKE = '#60a0ff';
export const TABLE_ICON_DISABLED_STROKE = '#808080';
export const SIDEBAR_STROKE = '#ffffff';
export const TABLE_ICON_RED = '#ff918f';

export const SELECCIONE = 'Seleccione';

export const VARIABLE_TYPE = 1;
export const RECORD_TYPE = 2;

export const GLOBAL_VAR_REGEX = /\$V\{(.*?)\}/g;

export const DOCUMENT_TYPES = Object.freeze({
  DNI: '3',
  RUT: '4',
});

export const STATE = Object.freeze({
  STATE_ACTIVE: 'ACTIVO',
  STATE_INACTIVE: 'INACTIVO',
  STATE_DELETED: 'ELIMINADO',
  ACTIVE_ID: 0,
  INACTIVATE_ID: 1,
  DELETED_ID: 2,
});

export const PROFILE = Object.freeze({
  STATE_ADMIN: 'Administrador',
  STATE_PROCESS_ADMIN: 'Administrador de Procesos',
  STATE_OPERATOR: 'Operador',
});

export const PROFILE_ID = Object.freeze({
  STATE_ADMIN: 1,
  STATE_PROCESS_ADMIN: 2,
  STATE_OPERATOR: 3,
});

export const TypesDND = Object.freeze({
  VARIABLES: 1,
  REGISTERS: 2,
  SECTIONS: 3,
  TAB: 4,
});

export const TypesVariableDND = Object.freeze({
  INPUT: 1,
  SELECT: 2,
  TEXTBOX: 4,
  CALENDAR: 5,
  FILEUPLOAD: 6,
  RADIO_BUTTON: 7,
  CHECKBOX: 8,
  GEOLOCATION: 9,
});

export const TypesEntityDND = Object.freeze({
  USER: 'Usuario',
  GROUP: 'Grupo',
  VARIABLE: 'Variable',
  EXECUTOR: 'Ejecutor de',
  CREATOR: 'Creador de Proyecto',
  VARIABLE_GROUP: 'Variable - Grupo',
});

export const EntityIdDND = Object.freeze({
  USER: 1,
  GROUP: 2,
  VARIABLE: 3,
  EXECUTOR: 4,
  CREATOR: 5,
  VARIABLE_GROUP: 6,
});

export const JBPM_FOUND_ERROR = Object.freeze({
  NOT_IMPLEMENTATION_ID_FOUND: 'cannot find container',
  NOT_DEFINITION_ID_FOUND: 'no process available',
});

export const ORIGIN_TYPE_SELECTION = Object.freeze({
  INF_SOURCE: 1,
  // QUERY_SQL: 2,
});

export const TASKS_FILTER = Object.freeze({
  RECEIVED_TASK: 1,
  ACCEPTED_ASSIGNMENTS: 2,
  ALL: 3,
});

export const LAYOUT_LIST = Object.freeze([
  {
    id: 'horizontal_table',
    name: 'Tabla Horizontal',
  },
  {
    id: 'vertical_table',
    name: 'Tabla Vertical',
  },
]);

export const LAYOUT_TYPE = Object.freeze({
  HORIZONTAL_TABLE: 'horizontal_table',
  VERTICAL_TABLE: 'vertical_table',
});

export const EXTERNAL_SOURCE_TYPES = Object.freeze([
  {
    id: 'Postgres',
    name: 'Postgres',
  },
  {
    id: 'SQLServer',
    name: 'SQL Server',
  },
]);

export const TYPE_COMPONENT_LIST = Object.freeze([
  {
    id: 'BDC_MINDIVIDUAL',
    name: 'Conector BD - Mapeo Individual',
  },
  {
    id: 'BDC_MMULTIPLE',
    name: 'Conector BD - Mapeo Múltiple',
  },
  {
    id: 'ARC_MMULTIPLE',
    name: 'Conector API Rest - Mapeo Múltiple',
  },
]);

export const TYPE_COMPONENT = Object.freeze({
  INDIVIDUAL_MAPPING_BDC: 'BDC_MINDIVIDUAL',
  MULTIPLE_MAPPING_BDC: 'BDC_MMULTIPLE',
  MULTIPLE_MAPPING_ARC: 'ARC_MMULTIPLE',
});

export const SECRET_KEY = Object.freeze({
  KEY: 'P_Jvv2_T!XJgJLs',
});

export const NO_VALUES_FORM_NAMES = Object.freeze({
  USERS: 'usuarios',
  GROPS: 'grupos',
  ROLES: 'roles',
  COMPONENTS: 'componentes',
  SECUENCES: 'Secuencias',
  TEMPLATES: 'Plantillas',
  USER_TASKS: 'Tareas para este usuario',
  PERMISSIONS: 'permisos',
});

export const JBPM_TASK_STATUS = Object.freeze({
  CREATED: 'Created',
  READY: 'Ready',
  RESERVED: 'Reserved',
  IN_PROGRESS: 'InProgress',
  SUSPENDED: 'Suspended',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  ERROR: 'Error',
  EXITED: 'Exited',
  OBSOLETE: 'Obsolete',
});

export const PERMISSIONS = Object.freeze({
  CREATION: 'CREACION_DE_TRAMITES',
  SEARCH: 'BUSQUEDA_DE_TRAMITES',
  MONITORING: 'VER_ESTADISTICAS_DE_TRAMITES',
  REASSIGN: 'REASIGNAR_TAREA',
  TASK_PENDING_USER: 'TAREAS_PENDIENTES_POR_USUARIO',
  PROCESS_HISTORY: 'HISTORICO_DE_PROCESOS',
  MONTHLY_MANAGEMENT: 'GESTION_MENSUAL',
  MONTHLY_MANAGEMENT_BY_AREA: 'GESTION_MENSUAL_AREA',
  PROCESS_REPORTS_MUNICIPALITY: 'DEMANDA_DIRECTA',
  AUDITORIA: 'AUDITORIA',
});

export const FORM_VIEW_TYPE = Object.freeze({
  CREATION: 1,
  EDITION: 2,
  VIEW: 3,
  PREVIEW: 4,
});

export const GROUP_TYPE_DESCRIPTOR = Object.freeze({
  ATENCION_CIUDADANA: 'ATENCION_CIUDADANA',
});

export const ATENCION_CIUDADANA = Object.freeze({
  ACTIVO: 1,
  INACTIVO: 0,
});

export const STATE_PROCESS = Object.freeze({
  ABIERTO: 1,
  CERRADO: 2,
});
